export default "__VITE_ASSET__2cedIDRQ__";